// extracted by mini-css-extract-plugin
export var aiStarIcon = "_bp-4";
export var closeButton = "_bp-6";
export var dismissButton = "_bp-3";
export var editImageWithAiContainer = "_bp-8";
export var imageUploadWrapper = "_bp-7";
export var misspelledWord = "_bp-5";
export var spellCheckContainer = "_bp-2";
export var spin = "_bp-1";
export var spinning = "_bp-0";